import React from "react";

const Error404 = () => {
    return (
        <div className="flex items-center justify-center h-screen bg-gradient-to-br from-purple-600 ... ... to-indigo-600">
            <div className="text-center text-white">
                <h1 className="text-6xl mb-4">Oops!</h1>
                <p className="text-2xl mb-4">
                    We're sorry, the page you're looking for is under
                    development.
                </p>
                <p className="text-lg mb-8">
                    We are currently developing this page. Please visit again
                    later.
                </p>
                <a
                    href="/"
                    className="bg-white text-indigo-600 font-bold py-2 px-4 rounded-lg hover:bg-indigo-600 hover:text-white transition duration-300"
                >
                    Go back to home
                </a>
            </div>
        </div>
    );
};

export default Error404;
